import React, { useState, useEffect } from 'react';
import { HiChevronLeft } from 'react-icons/hi';

function BookingCinnamonLodge() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Load Bokun widget script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://widgets.bokun.io/assets/javascripts/apps/build/BokunWidgetsLoader.js?bookingChannelUUID=69e6f133-c650-4f54-b7e8-13868b3d6afe';
    script.async = true;
    
    script.onload = () => {
      // Script loaded, hide loading screen after a brief delay
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    };

    document.head.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white text-[#3f3a32]">
      
      {/* Go Back */}
      <div className="px-4 py-6">
        <a href="/" className="flex items-center text-[#3f3a32] font-semibold text-base mb-4 hover:underline">
          <HiChevronLeft className="text-lg" />
          Go back
        </a>
      </div>

      {/* Booking Widget Container */}
      <div className="relative w-full min-h-screen">
        {/* Loading Screen */}
        {isLoading && (
          <div className="absolute inset-0 bg-white flex flex-col items-center justify-center z-10">
            <div className="text-center">
              {/* Loading Spinner */}
              <div className="w-16 h-16 border-4 border-[#7c623f] border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
              
              {/* Loading Text */}
              <h2 className="text-2xl font-bold text-[#3f3a32] mb-2 font-mortend">
                Loading Booking Page
              </h2>
              <p className="text-[#7c623f] text-lg">
                Please wait while we prepare your booking experience...
              </p>
              
              {/* Animated dots */}
              <div className="flex justify-center mt-4 space-x-1">
                <div className="w-2 h-2 bg-[#7c623f] rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-[#7c623f] rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                <div className="w-2 h-2 bg-[#7c623f] rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
              </div>
            </div>
          </div>
        )}

        {/* Bokun Widget */}
        <div 
          className={`bokunWidget transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
          data-src="https://widgets.bokun.io/online-sales/69e6f133-c650-4f54-b7e8-13868b3d6afe/experience/936576"
        ></div>
        
        <noscript>
          <div className="p-8 text-center">
            <p className="text-[#3f3a32] text-lg">Please enable JavaScript in your browser to book</p>
          </div>
        </noscript>
      </div>

    </div>
  );
}

export default BookingCinnamonLodge;
